export const RESUME_WRITING_SERVICE_PAGE_URL =
  'https://topresume.com/resume-writing?pt=i0QW9X0jKNv3w&utm_source=careerio&utm_medium=cioplatform&utm_campaign=tr_cta_in_cio_critique_v1&utm_content=cta2'
